export default "/_next/static/src/assets/videos/d840169f3ed9d3dd94edb35024ba27f1.mp4";